<template>
  <div class="flex flex-row gap-4 w-full">
    <!-- <b-col sm="12" md="12" lg="2" hidden>
            <b-form-group class="text-left" :content-cols="12" label-for="tipo_select-select">
                <select  v-model="nuevoSelect" @change="showSelect" required>
                    <option value="0" disabled>Selección</option>
                    <option value="1">Individual</option>
                    <option value="2">Multiple</option>
                </select>
            </b-form-group>
        </b-col> -->
    <div>
      <select v-model="nuevoTipo" @change="tipo(nuevoTipo)" required>
        <option value="0" disabled>Selecciona un Rol</option>
        <option
          v-for="(tipo, index) in tiposUsuario"
          :key="index"
          :value="tipo.value"
        >
          {{ tipo.text }}
        </option>
      </select>
    </div>
    <div sm="12" md="12" lg="5">
      <div v-if="usuarios.length > 0">
        <select v-model="nuevoUsuario" @change="user(nuevoUsuario)" required>
          <option value="0" disabled>Selecciona un usuario</option>
          <option
            v-for="(usuario, index) in usuarios"
            :key="index"
            :value="usuario.id"
          >
            {{ usuario.name }}
          </option>
        </select>
      </div>
      <div v-else-if="usuarios.length <= 0 && nuevoTipo != 0">
        No hay usuarios disponibles
      </div>
    </div>
    <div class="flex flex-row items-center gap-4">
      <slot></slot>

      <button class="btn-principal" type="submit">Asignar</button>
    </div>
  </div>
</template>

<script>
/* import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'; */

export default {
  /* components: {
        vueMultiSelect,
    }, */
  props: {
    listaUsuarios: Object,

    submit: Function,
    titulo: String,
    campo: String,
    seccion: String,
    changeForm: Function,
    changeUser: Function,

    changeTipo: Function,

    id: String,

    usuarios: Array,
    tipoUsuario: String,
    usuario: Number,

    tiposUsuario: Array,
  },
  data() {
    return {
      nuevoUsuario: 0,

      nuevoTipo: 0,

      nuevoSelect: 0,

      /* mostrarSelect: false,

            mostrarSelect2: false,

            listaUsuariosSelect: [],

            selected: null,

            filters: [{
                nameAll: 'Select all',
                nameNotAll: 'Deselect all',
                func() {
                    return true;
                },
            }],
            position: 'top-right',
            options: {
                multi: true,
                groups: false,
                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            }, */
    };
  },

  watch: {
    usuario: function (newValue, oldValue) {
      this.nuevoUsuario = this.usuario;
    },
    tipoUsuario: function (newValue, oldValue) {
      this.nuevoTipo = this.tipoUsuario;
    },
  },
  methods: {
    tipo(tipo) {
      this.nuevoTipo = this.changeTipo(tipo);
    },
    user(id) {
      this.nuevoUsuario = this.changeUser(id);
    },
  },
};
</script>

<style></style>
